var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.filteredResults.length
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.onScroll,
                  expression: "onScroll",
                },
              ],
              staticClass: "m-search-results",
            },
            _vm._l(_vm.filteredResults, function (item, index) {
              return _c("template-card", {
                key: index,
                attrs: {
                  item: item,
                  quantity: item.quantity,
                  showControls: _vm.showControls,
                  isFavourite: _vm.isFavourite(item),
                },
                on: {
                  setQuantity: _vm.setQuantity,
                  shareItem: _vm.shareItem,
                  addFavourite: function ($event) {
                    return _vm.addFavourite(item, index)
                  },
                  removeFavourite: function ($event) {
                    return _vm.removeFavourite(item, index)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.filteredResults.length ? _c("no-results") : _vm._e(),
      _vm._v(" "),
      _c("share-modal", {
        attrs: { visible: _vm.shareModalVisible, url: _vm.shareUrl },
        on: {
          "update:visible": function ($event) {
            _vm.shareModalVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }